function propErrorHandlingProxy(resolvable, fallback, onError) {
  return {
    ...resolvable,
    readStable: () => {
      try {
        return resolvable.readStable();
      } catch (err) {
        onError?.(err);
        return fallback;
      }
    }
  };
}
export {
  propErrorHandlingProxy
};
//# sourceMappingURL=prop-error-handling-proxy.js.map